import React, { useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { cn } from './Button';

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 3500);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={cn(
      "fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-6 py-4 rounded-2xl shadow-2xl border animate-in slide-in-from-top-4 fade-in duration-300 min-w-[280px] max-w-[90vw]",
      type === 'success' ? "bg-white border-green-100 text-green-700" :
      type === 'error' ? "bg-white border-red-100 text-red-600" :
      "bg-white border-blue-100 text-blue-600"
    )}>
      <div className={cn(
        "w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0",
        type === 'success' ? "bg-green-50" : type === 'error' ? "bg-red-50" : "bg-blue-50"
      )}>
        <SafeIcon name={type === 'success' ? 'CheckCircle' : type === 'error' ? 'XCircle' : 'Info'}
          className="text-sm" />
      </div>
      <p className="font-bold text-sm flex-1">{message}</p>
      <button onClick={onClose} className="text-gray-300 hover:text-gray-500 transition-colors ml-2">
        <SafeIcon name="X" className="text-xs" />
      </button>
    </div>
  );
}